import { Routes } from '@angular/router';
import { machineDetailResolver } from './resolvers/machine-detail.resolver';

export const machineCatalogRoutes = [
  {
    path: 'machine-catalog',
    children: [
      {
        path: 'search',
        loadComponent: () => import('./pages/machine-search/machine-search'),
      },
      {
        path: ':id',
        resolve: { machineDetailResolver: machineDetailResolver },
        loadComponent: () => import('./pages/machine-detail/machine-detail'),
      },
      {
        path: '**',
        redirectTo: 'machine-catalog/search',
      },
    ],
  },
] satisfies Routes;
